:host {
  display: block;
}

.sportsline-expert {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.sportsline-expert__box {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}

.sportsline-expert__info {
  display: flex;
  flex-direction: column;
}

.sportsline-expert__name {
  color: var(--Text-Primary, #202121);
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 1.12px;
  text-transform: uppercase;
}

.sportsline-expert__ranking {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.125rem;
}

.sportsline-expert__ranking-number {
  color: var(--Text-Tertiary, #767676);
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.2;
}

.sportsline-expert__streak {
  display: flex;
  font-size: 0.875rem;
  flex-direction: row;
  align-items: baseline;
  gap: 0.5rem;
  white-space: nowrap;
}

.sportsline-expert__streak-label {
  color: var(--Text-Tertiary, #767676);
  font-style: normal;
  font-family: 'FS Industrie', 'FSIndustrie-Bold', 'industrie-standard', Helvetica, Arial, sans-serif;
  font-weight: 500;
  line-height: 1.2;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}

.sportsline-expert__streak-label-stats {
  color: var(--text-positive-color);
}

sportsline-expert-avatar {
  display: flex;
}
